// extracted by mini-css-extract-plugin
export default {"aboutKnowMe":"AboutKnowme_aboutKnowMe__nyXGg","aboutKnowMe-h3":"AboutKnowme_aboutKnowMe-h3__eTf42","aboutKnowMe-p":"AboutKnowme_aboutKnowMe-p__Ec3Lu"};